import React, { useState } from "react";
import "./ForgotPasswordPage.css";
import { verifyAccount } from '../../_services/authServices'
import { useNavigate } from 'react-router-dom';
import Loader from '../../components/Loader';
import AlertBox from '../../components/AlertBox';

import { useUser } from "../../context/UserContext";

const ForgotPasswordPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [validated, setValidated] = useState(false);
  const [emailAddress, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [alert, setAlert] = useState({ show: false, message: "", type: "info" });

  const { user } = useUser();

  if(user) {
    navigate("/choose-profile", {replace: true})
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
  
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }

    setLoading(true);
    setValidated(true);

    try {
      const result = await verifyAccount(emailAddress);
      
      if (result.success === true) {
        setAlert({
          show: true,
          message: result.message,
          type: "success",
        });
        setSent(true);
        setLoading(false);
      }else{
        setTimeout(() => {
          setAlert({
            show: true,
            message: result.message,
            type: "error",
          });
          setLoading(false);
        }, 2000);
        
      }
    } catch (error) {
      setTimeout(() => {
        setAlert({
          show: true,
          message: error.message || `Something went wrong. Please try again.`,
          type: "error",
        });
      setLoading(false);
      }, 2000);
    } 
  };

  return (
    <div className="forgot-wrapper">
      <Loader show={loading} message="Authenticating, please wait..." />
      
      <AlertBox
        show={alert.show}
        message={alert.message}
        type={alert.type}
        onClose={() => setAlert({ ...alert, show: false })}
      />
      <div className="forgot-card">

        {!sent ? (
          <>
          <div className="logo-container">
            <img src="/images/logo.png" alt="Logo" />
          </div>

            <h2 className="title">Forgot Password?</h2>
            <p className="subtitle">
              Enter your email and we’ll send you a reset link.
            </p>

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  type="email"
                  placeholder="Enter your email"
                  value={emailAddress}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <button type="submit" className="btn">
                Send Reset Link
              </button>
            </form>

            <p className="back-link">
              Remember your password? <a href="/login">Login</a>
            </p>
          </>
        ) : (
          <div className="success">
            <div className="icon">✔</div>
            <h2>Check your email</h2>
            <p>
              A password reset link has been sent to <strong>{emailAddress}</strong>
            </p>

            <a href={`/verify-otp/?emailAddress=${emailAddress}`} className="btn">
              Enter Verification Code
            </a>
          </div>
        )}

      </div>
    </div>
  );
};

export default ForgotPasswordPage;